(function($) {
    $(document).ready(function() {

        function scrollTo(hash) {

            hashName = '#' + hash;
            target = $(hashName);

            $('html, body').animate({
                scrollTop: target.offset().top - 100
            }, 1000);
        }

        function isWhole(n) {
            return /^\d+$/.test(n);
        }

        // A function to hide and show things based on checkboxes
        function activateOptions(target, checkbox) {

            // Slide up all the open options
            $('.is-open').slideUp().removeClass('is-open');

            // Uncheck the giftaid declaration
            $('#sos-giftaid').not(checkbox).prop('checked', false);

            // Find out if the checkbox is checked or not
            var condition = $(checkbox).prop('checked');

            // Make a jQuery object out of the target
            var $target = $(target);

            // If the box is ticked
            if (condition) {

                // Show the target container
                $target.slideDown();
                $target.addClass('is-open');

                // if the box is not ticked
            } else {

                // Hide the target container
                $target.slideUp();
                $target.removeClass('is-open');
            }
        }

        $('.js-donation-suggestion').on('click', function(e) {

            e.preventDefault();
            // Get the amount of the donation
            var donationAmount = $(this).attr('data-amount');

            // Scroll to the donate form
            scrollTo('donate');

            // update the input with value from data-amount
            setTimeout(function() {
                dealer.setValue(donationAmount / 100);
            }, 500);
        });

        // Set the donation amount based on the number of seats
        function seatsCost( seats, counter, target ) {

            // Get the input for the number of requested seats
            $seatsInput = $(seats);

            // Get the actual number of seats
            var $numberOfSeats = $seatsInput.val();

            // Work out the total dontation num of seats * £500
            var total = $numberOfSeats * 500;

            // Get the counter which displays the total
            var $counter = $(counter);

            // Get the input which gets sent to Stripe
            var $target = $(target);

            // Check if the number of seats is a whole number
            var isValid = isWhole($numberOfSeats);

            // Get the button used to donate
            var button =  $('.donate-submit');

            // Get the error display
            var error = $('#sos-form-error');

            // If is is a whole number
            if (isValid) {
                // Update the total display
                $counter.text(total);
                // Update the input which gets submitted
                $target.val(total);
                // Enable to donate button
                button.prop('disabled', false);
                // Check that everything is valid
                window.validate($numberOfSeats, button, error);
            } else {
                // If is it not a whole number
                // Diable the submit button
                button.prop('disabled', true);
                // Update the error message
                error.text('We can only provide whole seats');
                // Show the error message
                error.fadeIn();
            }

        }

        // Set the donation amount submitted for optional donation
        function otherDinnerDonation(inputValue, target) {

            // cache this input used
            var $this = $(inputValue);

            // Cache the number of seats
            var amount = $this.val();

            // Cahce the target input to be submitted to stripe
            var $target = $(target);

            // Get the donate button
            var button =  $('.donate-submit');
            // Get the error display
            var error = $('#sos-form-error');

            // Validate the inputs content
            window.validate(amount, button, error);

            // Update the input ready to be submitted to stripe
            $target.val(amount);

        }

        // When the number of seats is set
        $('.js-dinner-seat-number').on('keyup, change', function() {

            // Set donation amount based on number of seats
            seatsCost( this, '.js-seat-donation-total', '.js-dinner-seat-amount');

        });

        // When a donation amount is entered
        $('.js-total-donate').on('keyup, change', function() {

            // Set the donation amount for optional dinner donation
            otherDinnerDonation(this, '.js-dinner-amount');

        });


        // When the user clicks on the UK Check checkbox
        $('.check--uk').on('click', function() {

            // hide / show the gift aid information
            activateOptions('.gift-aid', this);
        });

        // When the user selects the dinner donate option
        $('.check--dinner-seat').on('change', function() {

            // Set donation amount based on number of seats
            seatsCost( '.js-dinner-seat-number', '.js-seat-donation-total', '.js-dinner-seat-amount');

            // hide / show the dinner donation options
            activateOptions('.dinner-options--seat', this);

        });

        // When the user selects the dinner donate option
        $('.check--dinner').on('change', function() {

            // Set the doantion amount for optional donation
            otherDinnerDonation('.js-total-donate', '.js-dinner-amount');

            // hide / show the dinner donation options
            activateOptions('.dinner-options', this);

        });

        // When the page loads, check if they are in the UK 
        // and hide / show the gift aid options
        activateOptions('.giftaid', 'check--uk');

    });
})(jQuery);
